import { render, staticRenderFns } from "./RetentionSalesReport.vue?vue&type=template&id=8dfa3270&scoped=true"
import script from "./RetentionSalesReport.vue?vue&type=script&lang=js"
export * from "./RetentionSalesReport.vue?vue&type=script&lang=js"
import style0 from "./RetentionSalesReport.vue?vue&type=style&index=0&id=8dfa3270&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dfa3270",
  null
  
)

export default component.exports